import dayjs from 'dayjs';
import React from 'react';
import './UserScoreCard.scss';

interface Props {
    count: number;
    comment: string;
    date: Date;
}

function UserScoreCard({ count, comment, date }: Props): React.ReactElement {
    return (
        <div className="user-score-card">
            <div
                className={`user-score-card_count ${
                    count > 0 ? 'positive' : 'negative'
                }`}
            >
                {count}
            </div>
            <div className="user-score-card_comment">{comment}</div>
            <div className="user-score-card_date">
                {dayjs(date).format('DD.MM.YY')}
            </div>
        </div>
    );
}

export default React.memo(UserScoreCard);
